module.exports = __webpack_public_path__ + "static/media/clipboard.ec0e3ce7.svg";